import React, { useState } from 'react';
import { Modal, Confirm } from 'semantic-ui-react';

export function BasicModal({ show, close, title, children, size = 'tiny' }) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  // Handle the close attempt
  const handleCloseAttempt = () => {
    setConfirmOpen(true); // Show the confirmation dialog
  };

  // Handle actual close
  const handleConfirmClose = () => {
    setConfirmOpen(false); // Close the confirmation dialog
    close(); // Close the modal
  };

  // Handle cancel close
  const handleCancelClose = () => {
    setConfirmOpen(false); // Just close the confirmation dialog
  };

  return (
    <>
      <Modal closeIcon open={show} onClose={handleCloseAttempt} size={size}>
        {title && <Modal.Header>{title}</Modal.Header>}
        <Modal.Content>{children}</Modal.Content>
      </Modal>
      <Confirm
        open={confirmOpen}
        onCancel={handleCancelClose}
        onConfirm={handleConfirmClose}
        content="¿Estás seguro de que quieres cerrar este formulario?"
      />
    </>
  );
}

